import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';

const UserRoleAssignment = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState(null);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const usersResponse = await api.get('/users');
        const rolesResponse = await api.get('/roles/roles');

        if (usersResponse && Array.isArray(usersResponse)) {
          setUsers(usersResponse);
        } else {
          console.error('Ошибка при получении списка пользователей: Некорректный формат данных', usersResponse);
          setError('Ошибка при получении списка пользователей. Некорректный формат данных');
        }

        if (rolesResponse && rolesResponse.data && Array.isArray(rolesResponse.data)) {
          setRoles(rolesResponse.data);
        } else {
            console.error('Ошибка при получении списка ролей: Некорректный формат данных', rolesResponse);
          setError('Ошибка при получении списка ролей. Некорректный формат данных');
        }
      } catch (error) {
        console.error('Ошибка при загрузке данных:', error);
        setError('Ошибка при загрузке данных');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleAssignRole = async () => {
    if (!selectedUser || !selectedRole) {
      setError('Выберите пользователя и роль');
      return;
    }
    setLoading(true);
    setError(null);
      try {
        await api.post(`/roles/users/${selectedUser}/roles`, { roleId: selectedRole});
          alert('Роль успешно присвоена');
    } catch (error) {
      console.error('Ошибка при назначении роли:', error);
      setError('Ошибка при назначении роли');
    } finally {
      setLoading(false);
    }
  };


    const getUserName = (user) => {
      if (user && user.username) {
        return user.username;
      }
      return `User ID: ${user.id}`;
    };


  return (
    <div>
      {loading && <div>Загрузка...</div>}
      {error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}
      <h2>Назначение ролей пользователям</h2>
      <div style={{ marginBottom: '15px' }}>
        <select
          value={selectedUser}
          onChange={e => setSelectedUser(e.target.value)}
          style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', marginRight: '10px' }}
        >
          <option value="">Выберите пользователя</option>
          {users.map(user => (
            <option key={user.id} value={user.id}>{getUserName(user)}</option>
          ))}
        </select>
        <select
          value={selectedRole}
          onChange={e => setSelectedRole(e.target.value)}
          style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', marginRight: '10px' }}
        >
          <option value="">Выберите роль</option>
          {roles && Array.isArray(roles) && roles.map(role => (
            <option key={role.id} value={role.id}>{role.name}</option>
          ))}
        </select>
        <button
          onClick={handleAssignRole}
          style={{ padding: '10px 15px', backgroundColor: '#4caf50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          disabled={loading}
        >
          {loading ? 'Отправка...' : 'Назначить роль'}
        </button>
      </div>
    </div>
  );
};

export default UserRoleAssignment;
